import React from "react";
import { Modal } from "antd";
import style from "./index.module.scss";
import { ModalProps } from "antd/lib/modal/Modal";

interface ProjectionModalProps extends ModalProps {
    title: string;
    visible: boolean;
    onCancel?: () => void;
    children: React.ReactNode;
}

export default function ProjectionModal(props: ProjectionModalProps) {
    return (
        <Modal
            width={1000}
            className={style.root}
            footer={null}
            maskClosable={false}
            getContainer={false}
            {...props}
        />
    );
}
